export const resultsFilter = {
    namespaced: true,

    state: {
        selectedTab: 'by-athlete',
        groupFilter: {
            selectedUserId: null,
            selectedAlternativeUserId: null,
            selectedSquadIds: [],
            showEverybody: true
        }
    },

    getters: {
        selectedTab(state) {
            return state.selectedTab;
        }
    },

    mutations: {
        selectTab(state, data) {
            state.selectedTab = data;
        },

        emptyGroupFilter(state) {
            Vue.set(state.groupFilter, 'selectedUserId', null);
            Vue.set(state.groupFilter, 'selectedAlternativeUserId', null);
            Vue.set(state.groupFilter, 'selectedSquadIds', []);
            Vue.set(state.groupFilter, 'showEverybody', true);
        }
    }
};
